import { IonCardTitle, IonCol, IonRow } from "@ionic/react";

const TOCItem = ({ name, inset }) => {
  return (
    <IonRow style={{ borderBottom: "1px solid #242424", padding: "0.5rem" }}>
      <IonCol size="9">
        <IonCardTitle
          style={{ fontSize: "0.9rem", marginLeft: inset ? "1.5rem" : "" }}
        >
          {name.indexOf(":") !== -1 ? name.split(":")[0] : "-"}
        </IonCardTitle>
      </IonCol>

      <IonCol size="3">
        <IonCardTitle style={{ fontSize: "0.9rem" }}>
          {name.indexOf(":") !== -1 ? name.split(":")[1].trim() : name}
        </IonCardTitle>
      </IonCol>
    </IonRow>
  );
};

export default TOCItem;
